import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';

const Aside = ({page}) => {
  
    const [role, setRole] = useState('')
    useEffect(() => {
        const user = localStorage.getItem('backend_vxs_user');
        if(user){
            const info = JSON.parse(user);
            setRole(info.role)
        }
    }, [])

       
    return (
        <aside className="left-sidebar" data-sidebarbg="skin5">
            <div className="scroll-sidebar">
                <nav className="sidebar-nav">
                    <ul id="sidebarnav" className="pt-4">
                        {
                        !page ? 
                        <li className="sidebar-item selected">
                                <Link
                                className="sidebar-link waves-effect waves-dark sidebar-link active" to="/">
                                    <i className="mdi mdi-view-dashboard"></i>&nbsp;<span className="hide-menu">Dashboard</span>
                                </Link>
                            </li>
                            :
                            <li className="sidebar-item">
                                <Link
                                className="sidebar-link waves-effect waves-dark sidebar-link" to="/">
                                    <i className="mdi mdi-view-dashboard"></i>&nbsp;<span className="hide-menu">Dashboard</span>
                                </Link>
                            </li>
                        }
                        {
                        role === 'admin' ? 
                            <>
                             {page === "activeusers" ?
                            <li className="sidebar-item selected">
                                <Link
                                className="sidebar-link waves-effect waves-dark sidebar-link active" to="/activeusers">
                                    <i className="fas fa-users"></i>&nbsp;<span className="hide-menu">Active users</span>
                                </Link>
                            </li>
                            :
                            <li className="sidebar-item">
                                <Link
                                className="sidebar-link waves-effect waves-dark sidebar-link" to="/activeusers">
                                    <i className="fas fa-users"></i>&nbsp;<span className="hide-menu">Active users</span>
                                </Link>
                            </li>
                            }
                            {page === "customers" ?
                            <li className="sidebar-item selected">
                                <Link
                                    className="sidebar-link waves-effect waves-dark sidebar-link active" to="/customers">
                                    <i className="fas fa-users"></i>&nbsp;<span className="hide-menu">Customers</span>
                                </Link>
                            </li>
                            :
                            <li className="sidebar-item">
                                <Link
                                className="sidebar-link waves-effect waves-dark sidebar-link" to="/customers">
                                    <i className="fas fa-users"></i>&nbsp;<span className="hide-menu">Customers</span>
                                </Link>
                            </li>
                            }
                             {page === "allusers" ?
                            <li className="sidebar-item selected">
                                <Link
                                    className="sidebar-link waves-effect waves-dark sidebar-link active" to="/allusers">
                                    <i className="fas fa-users"></i>&nbsp;<span className="hide-menu">Azure users</span>
                                </Link>
                            </li>
                            :
                            <li className="sidebar-item">
                                <Link
                                className="sidebar-link waves-effect waves-dark sidebar-link" to="/allusers">
                                    <i className="fas fa-users"></i>&nbsp;<span className="hide-menu">Azure users</span>
                                </Link>
                            </li>
                            }
                      
                            {page === "subscriptions" ?
                            <li className="sidebar-item selected">
                                <Link
                                className="sidebar-link waves-effect waves-dark sidebar-link active" to="/subscriptions">
                                    <i className="fas fa-money-bill-alt"></i>&nbsp;<span className="hide-menu">Subscriptions</span>
                                </Link>
                            </li>
                            :
                            <li className="sidebar-item">
                                <Link
                                className="sidebar-link waves-effect waves-dark sidebar-link" to="/subscriptions">
                                    <i className="fas fa-money-bill-alt"></i>&nbsp;<span className="hide-menu">Subscriptions</span>
                                </Link>
                            </li>
                            }

                            {page === "products" ?
                            <li className="sidebar-item selected">
                                <Link
                                className="sidebar-link waves-effect waves-dark sidebar-link active" to="/products">
                                    <i className="fab fa-product-hunt"></i>&nbsp;<span className="hide-menu">Products</span>
                                </Link>
                            </li>
                            :
                            <li className="sidebar-item">
                                <Link
                                className="sidebar-link waves-effect waves-dark sidebar-link" to="/products">
                                    <i className="fab fa-product-hunt"></i>&nbsp;<span className="hide-menu">Products</span>
                                </Link>
                            </li>
                            }
                        </>
                        : ''
                        }
                       
                    </ul>
                </nav>
            </div>
        </aside>
    )
}

export default Aside